import {
  reactive,
  computed,
  toRefs
} from '@vue/composition-api';

export default {
  setup () {
    const state = reactive({
      isMobile: computed(() => window.innerWidth <= 800 && window.innerHeight <= 600)
    });

    return {
      ...toRefs(state)
    };
  }
};
